export enum Direction {
    None = 0,
    LeftRight = 1,
    RightLeft = 2,
    BeforeAfter = 3
}